import { Injectable } from '@angular/core';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomNgbDatepickerConfig extends NgbDatepickerConfig {
  firstDayOfWeek = 7;
  minDate = { year: 1900, month: 1, day: 1 };
}
